import { Image } from "primereact/image";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../Constants/Icons";
import STRINGS from "../../Constants/Strings";
import {
  hideConversationPane,
  setDefaultConversation,
} from "../../Redux/ChatConversation/ChatConversationActions";
import { setHeaderQuestionTitle } from "../../Redux/Header/HeaderActions";
import { closeRightSidebar } from "../../Redux/RightSidebar/RightSidebarActions";
import { AppDispatch, RootState } from "../../Redux/Store";
import { useTheme } from "../../Theme/ThemeContext";
import { toggleUseExternalDocumentsModeFalse } from "../../Redux/Dashboard/DashboardActions";

function Header() {
  // Consume theme so component re-renders on changes
  useTheme();
  const Icon = ICONS();
  const dispatch = useDispatch<AppDispatch>();
  const { selectedIndex, selectedSubIndexesKey } = useSelector(
    (state: RootState) => state.Dashboard,
  );
  const { success } = useSelector((state: RootState) => state.IUnderstand);
  const { isOpen } = useSelector((state: RootState) => state.RightSidebar);
  const { question, fileName, breadcrumb } = useSelector(
    (state: RootState) => state.Header,
  );
  const navigate = useNavigate();

  const onNewChatClick = () => {
    dispatch(setHeaderQuestionTitle(""));
    dispatch(closeRightSidebar());
    dispatch(hideConversationPane());
    dispatch(setDefaultConversation());
    dispatch(toggleUseExternalDocumentsModeFalse());
    navigate(`/`);
  };

  return (
    <header className="header">
      <div className="cursor-pointer" onClick={onNewChatClick}>
        <Image
          src={Icon.LbmcLogoImg}
          className="lbmc-header-full cursor-pointer"
          alt="think"
        />
      </div>

      {success && (
        <>
          <div className="separator"></div>
          {fileName ? (
            <>
              <span className="researching-audit" title={fileName}>
                {fileName}
              </span>
              {breadcrumb && breadcrumb.length > 0 && (
                <span className="researching-audit-title ml-2 text-secondary text-14">
                  {breadcrumb.join(" > ")}
                </span>
              )}
            </>
          ) : (
            <>
              <span className="researching-audit" title={question}>
                {question.length > 50
                  ? `${question.slice(0, 50)}...`
                  : question}
              </span>
              {!isOpen && (
                <span className="researching-audit-title ml-2 text-secondary text-14">
                  {STRINGS.HEADER.TITLE} {selectedIndex} {selectedSubIndexesKey}
                </span>
              )}
            </>
          )}
        </>
      )}
    </header>
  );
}

export default Header;
